const GENERAL = 'GENERAL';
const ACCOUNTING = 'ACCOUNTING';

const DashboardCategory = {
  GENERAL,
  ACCOUNTING,
} as const;

export default DashboardCategory;
